import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ValidateVertiRelationsFailure, ValidateVertiRelationsRequest, ValidateVertiRelationsSuccess } from './actions';
import { ValidatePolicy, ValidationResponse } from '@models/swagger';
import { ValidateVertiRelationsParams, ValidateVertiRelationsService } from './service';

@Injectable()
export class ValidateVertiRelationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly validateVertiRelationsService = inject(ValidateVertiRelationsService);

  validateVertiRelations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ValidateVertiRelationsRequest),
      switchMap(({ body, parameters }: { body: ValidatePolicy; parameters?: ValidateVertiRelationsParams }) =>
        this.validateVertiRelationsService.validateVertiRelations(body, parameters).pipe(
          map((data: ValidationResponse) => ValidateVertiRelationsSuccess({ data })),
          catchError(error => of(ValidateVertiRelationsFailure({ error })))
        )
      )
    )
  );

}
